import React, { Fragment } from 'react'
import { FiX } from 'react-icons/fi'
import CouponBottomLines from './CouponBottomLines'
import { CouponWithCompany } from '../../context/BookletCouponsContext';
import { Booklet, CompanyCategory } from '../../types/generated.types';

const { REACT_APP_IMAGE_BASE_URL } = process.env;

interface CouponItemProps {
  index: number;
  coupon: CouponWithCompany;
  onCouponRemove: (index: number) => void;
  bookletColor: string;
  companyCategories: CompanyCategory[];
  selectedBooklet?: Booklet | null;
}

const CouponItem: React.FC<CouponItemProps> = ({ index, coupon, onCouponRemove, bookletColor, companyCategories, selectedBooklet }) => {
  const category = coupon.company?.companyCategoryId ?
    companyCategories.find(cat => cat._id === coupon.company?.companyCategoryId) :
    null;


  // Get category color from booklet's categorySettings
  const categoryColor = category && selectedBooklet?.categorySettings?.find(
    setting => setting.categoryId === category._id
  )?.color || bookletColor;


  return (
    <Fragment>
      <button
        className="remove-btn"
        onClick={(e) => {
          e.stopPropagation();
          onCouponRemove(index);
        }}
        title="Ta bort kupong"
      >
        <FiX size={14} />
      </button>
      <div className="coupon-content">
        {coupon.company?.logoURL && (
          <div className="company-logo-container">
            <img
              src={`${REACT_APP_IMAGE_BASE_URL}${coupon.company.logoURL}`}
              alt={coupon.company.name}
              className="company-logo"
            />
          </div>
        )}
        <div className="coupon-details">
          <h4>{coupon.discount}</h4>
          <p>{coupon.smallTitle}</p>
          {/* {coupon.terms && <p className="terms">{coupon.terms}</p>} */}
        </div>
        {coupon.company && (
          <div className="company-info">
            <p className="company-name">{coupon.company.name}</p>
            {coupon.company.visitAddress && (
              <p className="company-address">
                {[
                  coupon.company.visitAddress.streetAddress,
                  coupon.company.visitAddress.zipCode,
                  coupon.company.visitAddress.city
                ].filter(Boolean).join(', ')}
              </p>
            )}
          </div>
        )}
      </div>
      <div className="coupon-bottom-lines">
        <CouponBottomLines color={bookletColor} />
        <div className="gradient-overlay"></div>
      </div>
      {category && (
        <div className="coupon-category-group" style={{ background: categoryColor }}>
          <p>{category.name}</p>
        </div>
      )}
    </Fragment>
  )
}

export default CouponItem
